import Spinner from "../../../components/common/Spinner/Spinner";

import {
  Grid,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Stack,
  Pagination,
  TableFooter,
} from "@mui/material";
import classNames from "classnames";
import { toUpper } from "lodash"
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./List.module.scss";
import { AppState } from '@configs/store/rootReducer';
import { openToast } from '@redux/toast/actions';
import Toast from "@components/common/Toast/toast";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserRequest } from "@redux/User/action";
import AccountToolbar from "@components/common/toolbar";
import endpoints from '../../../helpers/endpoints'
import fetch from '../../../utils/fetch'
import useDebounce from "@components/common/Debounce/useDebounce";

const UserList = () => {
  const dispatch = useDispatch();

  const [selectedArray, setSelectedArray] = useState<any>([]);
 
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [list, setList] = useState<any>({});

  const { loading } = useSelector((state: any) => ({
    loading: state?.toUserManager.loading,
  }));
  const [isLoading, setLoading] = useState<any>(null)
  useEffect(()=>{
    setLoading(loading)
  },[loading])
  const { userResult, totalPageUser } = useSelector((state: AppState) => state.toUserManager)
  
  //========================= new code ===========================//

  const columnTitle = [
    { name: 'STT' },
    { name: 'Tên user' },
    { name: 'Số điện thoại' },
    { name: 'Email' },
    { name: 'Gói dịch vụ' },
    { name: 'Ngày đăng ký' },
    { name: 'Ngày bắt đầu' },
    { name: 'Ngày kết thúc' },
    { name: 'Code tĩnh' },
    { name: 'Code động' }
  ]
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(0)
  const [inputValue, setInputValue] = useState<string>("")
  const [dateFilter, setDateFilter] = useState<any>();
  const [typeRetake, setTypeRetake] = useState<boolean>(false);
  const [serviceFilter, setServiceFilter] = useState<any>();

  function ControlledPagination() {
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
    };

    return (
      <Pagination
        count={totalPage}
        page={page}
        onChange={handleChange}
        variant="outlined"
        shape="rounded"
      />
    );
  }
  const delayInput = useDebounce(inputValue, 550)

  useEffect(() => {
    
    dispatch(fetchUserRequest({ params: { page: page, email: delayInput, createAt: dateFilter, plan: serviceFilter } }));
  }, [page, delayInput, dateFilter, serviceFilter])

  useEffect(() => {
    setList(userResult)
    setTotalPage(totalPageUser)
  }, [userResult])
  const navigate = useNavigate();
  const onSubmit = (e: any) => {
  }

  const submitRetake = (body: any): void =>  {
    fetch(endpoints.RETAKE, {
        body: JSON.stringify(body),
        secure: true,
        method: 'POST',
        headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    })
        .then(({ status, body }) => {
            if (status >= 400) {
                if (body.message === 'Not found qrocde!!') {
                    setTypeRetake(true)
                } else {
                    alert(body.message)
                }
            } else {
                alert("Lấy lại code thành công!!")
                setAnchorEl(null)
            }
        })
        .catch(error => {
        }) 
}

const createQrCode = async (body: any) => {
    const resultCreateQrcodeIamge = await fetch(process.env.REACT_APP_QRCODE_GENERATOR + '/qrcode-url', {
        body: JSON.stringify({ content: `${process.env.REACT_APP_DYNAMIC_CODE}/${body.id}`, contentType: 'url' }),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    });
    const validateAdmin = await fetch(endpoints.VALIDATE, {
        body: JSON.stringify({ isDynamicCode: true, email: body.email }),
        secure: true,
        method: 'POST',
        headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    })
    if (validateAdmin.status !== 200) {
        alert("User không thể tạo thêm code!")
        return;
    }
    const splitName = resultCreateQrcodeIamge?.body?.qrImage?.split("/");
    const linkCopyCode = resultCreateQrcodeIamge?.body?.dirName + "/" + splitName[splitName.length - 1];
    const copyCode = await fetch(process.env.REACT_APP_QRCODE_GENERATOR + '/copy-qrcode', {
        body: JSON.stringify({ link: linkCopyCode }),
        secure: true,
        method: 'POST',
        headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    });

    const url = body.url.startsWith('http') || body.url.startsWith('https') ? body.url : 'https://' + body.url;
    const saveCode = await fetch(endpoints.CREATE_NEW, {
        body: JSON.stringify({
            codeContent: JSON.stringify({ content: url }),
            codeRedirect: `${process.env.REACT_APP_DYNAMIC_CODE}/${body.id}`,
            contentType: "Website",
            dynamicId: body.id,
            isDynamicCode: "true",
            qrImageUrl: resultCreateQrcodeIamge.body?.qrImage.replace('generate_unsave', 'generate'),
            email: body.email
        }),
        secure: true,
        method: 'POST',
        headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    })
    if (saveCode.status === 200) {
        alert("Taọ QR code thành công!!")
        setAnchorEl(null)
        setTypeRetake(false)
    } else {
        setAnchorEl(null)
        setTypeRetake(false)
        alert("Đã có lỗi xảy ra!!")
    }
}
  /*
  const submitRetake = (body: any): void => {
    fetch("/cms/api/qrcode/user-codes/retake", {
      body: JSON.stringify(body),
      secure: true,
      method: 'POST',
      headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json', "Authorization": "Bearer 0.304839133465671930.78096973078987530.8925450358544695" }
    })
      .then(({ status, body }) => {
        if (status >= 400) {
          if (body.message === 'Not found qrocde!!') {
            setTypeRetake(true)
          } else {
            alert(body.message)
          }
        } else {
          alert("Lấy lại code thành công!!")
          setAnchorEl(null)
        }
      })
      .catch(error => {
      })
  }
  const createQrCode = async (body: any) => {
    const resultCreateQrcodeIamge: any = await fetch(process.env.REACT_APP_QRCODE_GENERATOR + '/qrcode-url', {
      body: JSON.stringify({ content: `${process.env.REACT_APP_DYNAMIC_CODE}/${body.id}`, contentType: 'url' }),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });
    const validateAdmin = await fetch(endpoints.VALIDATE, {
      body: JSON.stringify({ isDynamicCode: true, email: body.email }),
      // secure: true,
      method: 'POST',
      headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    })
    if (validateAdmin.status !== 200) {
      alert("User không thể tạo thêm code!")
      return;
    }
    const splitName = resultCreateQrcodeIamge?.body?.qrImage?.split("/");
    const linkCopyCode = resultCreateQrcodeIamge?.body?.dirName + "/" + splitName[splitName.length - 1];
    const copyCode = await fetch(process.env.REACT_APP_QRCODE_GENERATOR + '/copy-qrcode', {
      body: JSON.stringify({ link: linkCopyCode }),
      // secure: true,
      method: 'POST',
      headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    });

    const url = body.url.startsWith('http') || body.url.startsWith('https') ? body.url : 'https://' + body.url;
    const saveCode = await fetch(endpoints.CREATE_NEW, {
      body: JSON.stringify({
        codeContent: JSON.stringify({ content: url }),
        codeRedirect: `${process.env.REACT_APP_DYNAMIC_CODE}/${body.id}`,
        contentType: "Website",
        dynamicId: body.id,
        isDynamicCode: "true",
        qrImageUrl: resultCreateQrcodeIamge.body?.qrImage.replace('generate_unsave', 'generate'),
        email: body.email
      }),
      // secure: true,
      method: 'POST',
      headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json' }
    })
    if (saveCode.status === 200) {
      alert("Taọ QR code thành công!!")
      setAnchorEl(null)
      setTypeRetake(false)
    } else {
      setAnchorEl(null)
      setTypeRetake(false)
      alert("Đã có lỗi xảy ra!!")
    }
  }*/
  return (
    <React.Fragment>
      <Grid className={styles.ContentWrapper}>
        <Grid container className={styles.MenuNav} alignItems={"flex-end"}>
          <Link to="/admin/user-management" className={styles.MenuItemActive}>
            User
          </Link>
          {/* <Link to="/admin/order-management"
            className={styles.MenuItemUnActive}
          >
            Orders
          </Link> */}
        </Grid>
        <div className={styles.root}>
          <div className={styles.transactionToolbar}>
            <AccountToolbar
              inputValue={inputValue}
              setInputValue={setInputValue}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              dateFilter={dateFilter}
              setDateFilter={setDateFilter}
              onSubmit={onSubmit}
              submitRetake={submitRetake}
              typeRetake={typeRetake}
              setTypeRetake={setTypeRetake}
              createQrCode={createQrCode}
              setServiceFilter={setServiceFilter}
            />
          </div>
        </div>
        <Grid container direction={"column"} className={styles?.Wrapper}>
          {list && Object.keys(list).length > 0 ? (
            <>
              <Table>
                <TableHead sx={{ backgroundColor: '#F6F6F7' }}>
                  <TableRow>
                    {columnTitle.map((value: any, index: any) => {
                      return (
                        <TableCell align="center" key={index}>
                          <Typography className={styles.TableCellTitle} sx={{ fontWeight: '600' }}>
                            {value.name}
                          </Typography>
                        </TableCell>
                      )
                    }
                    )}
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {list?.map((element: any, index: any) => {
                    return (
                      <TableRow
                        onClick={() => {navigate("/payment-customer/" + element._id) }}
                        key={index}
                        className={classNames(
                          styles.PaperItem,
                          styles.OrderItem,
                          selectedArray.includes(element.default) && styles.PaperActive
                        )}
                      >
                        <TableCell align="center">{(page - 1) * 10 + index + 1}</TableCell>
                        <TableCell align="center">{element.firstName} {element.lastName}</TableCell>
                        <TableCell align="center">{element.phone}</TableCell>
                        <TableCell align="center">{element.email}</TableCell>
                        <TableCell align="center">{element.plan.replace(/^./, (str: string) => str.toUpperCase())}</TableCell>
                        <TableCell align="center">{new Date(element.createdAt || Date.now()).toLocaleDateString('vi')}</TableCell>
                        <TableCell align="center">{element.startAt ? new Date(element.startAt).toLocaleDateString('vi') : '-'}</TableCell>
                        <TableCell align="center">{element.endAt ? new Date(element.endAt).toLocaleDateString('vi') : '-'}</TableCell>
                        <TableCell align="center">
                          {element.codeStatistics?.staticCode ? 
                            `${element.codeStatistics.staticCode.used}/${element.codeStatistics.staticCode.limit}` : 
                            '-'
                          }
                        </TableCell>
                        <TableCell align="center">
                          {element.codeStatistics?.dynamicCode ? 
                            `${element.codeStatistics.dynamicCode.used}/${element.codeStatistics.dynamicCode.limit}` : 
                            '-'
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Grid container display="flex" justifyContent="center" mt={5}>
                <Stack spacing={2}>
                  <ControlledPagination />
                </Stack>
              </Grid>
            </>
          ) : (
            <div className={styles.DataEmpty}>Không có dữ liệu</div>
          )}

          {isLoading && <Spinner />}
        </Grid>
      </Grid>

      <Toast />
    </React.Fragment>
  );
};

export default UserList;
